import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default function createStore() {
	return new Vuex.Store({
		state: {
			host: '',
			// deviceType: 'pc',
			deviceType: 'mobile',
			showDebug: false,
			adPosConfig: {
				categories: [4, 10, 16],
				categoriesPC: [12],
			},
			adsensConfig: {
				scriptUrl: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1199535854231395',
				home_1: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-1199535854231395',
					'data-ad-slot': '1483065452',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				home_2: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-1199535854231395',
					'data-ad-slot': '7417084265',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				home_3: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-1199535854231395',
					'data-ad-slot': '7662843885',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				home_4: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-1199535854231395',
					'data-ad-slot': '7662843885',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				detail_1: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-1199535854231395',
					'data-ad-slot': '6343675742',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				detail_2: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-1199535854231395',
					'data-ad-slot': '5030594073',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				detail_3: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-1199535854231395',
					'data-ad-slot': '5030594073',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				chapter_1: {
					style: 'display:block',
					'data-ad-client': 'ca-pub-1199535854231395',
					'data-ad-slot': '2404430739',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
					class: 'adsbygoogle',
				},
				categories: [
					{
						style: 'display:block',
						'data-ad-client': 'ca-pub-1199535854231395',
						'data-ad-slot': '6543820447',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
						class: 'adsbygoogle',
					},
					{
						style: 'display:block',
						'data-ad-client': 'ca-pub-1199535854231395',
						'data-ad-slot': '3917657106',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
						class: 'adsbygoogle',
					},
					{
						style: 'display:block',
						'data-ad-client': 'ca-pub-1199535854231395',
						'data-ad-slot': '3917657106',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
						class: 'adsbygoogle',
					},
				],
			},
			domainConfig: {
				siteName: 'Cove of Captivation',
				siteIcon: '/icon/10.svg',
				IAMEMAIL: 'contact@novelscove.com',
				IAmURL: 'novelscove.com',
				ABOUTUS: 'Find your escape in our cove of captivating novels.',
				meta: {
					title: 'NovelsCove - Escape with Captivating Novels',
					des: 'Find your escape in our cove of captivating novels.',
				},
				firebase: {
					apiKey: 'AIzaSyBaw0uyzaIC2XlMxp_VSD2uLzNXWwqt0ZA',
					authDomain: 'web-pub-373-3.firebaseapp.com',
					projectId: 'web-pub-373-3',
					storageBucket: 'web-pub-373-3.firebasestorage.app',
					messagingSenderId: '966182307978',
					appId: '1:966182307978:web:1c5365d763f1328a0a4573',
					measurementId: 'G-95WDWMLZWG',
				},
				homeModules: ['topBooks', 'editorsChoice', 'recentlyUpdated', 'popularCategories', 'rankings'],
				bannerDesign: 2,
				ads: 'google.com, pub-4190396395519373, DIRECT, f08c47fec0942fa0',
				adsense: {
					scriptUrl: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4190396395519373',
				},
			},
			categories: [],
			categoriesLoaded: false,
			recommendList: [],
		},
		mutations: {
			setHost(state, host) {
				state.host = host
			},
			setTitle(state, title) {
				state.title = title
			},
			setDomain(state, domainConfig) {
				state.domainConfig = domainConfig
			},
			setDeviceType(state, deviceType) {
				state.deviceType = deviceType
			},
			setDebug(state, showDebug) {
				state.showDebug = showDebug
			},
			setAdsense(state, adsenseConfig) {
				state.adsensConfig = adsenseConfig
			},
			SET_CATEGORIES(state, categories) {
				state.categories = categories
				state.categoriesLoaded = true
			},
			SET_RECOMMEND_LIST(state, list) {
				state.recommendList = list
			},
			// 设置品牌列表
			SET_BRAND_LIST(state, brandList) {
				state.brandList = brandList
			},
		},
		getters: {
			showDebug: (state) => state.showDebug,
			deviceType: (state) => state.deviceType,
			host: (state) => state.host,
			adsensConfig: (state) => state.adsensConfig,
			adPosConfig: (state) => state.adPosConfig,
			domainConfig: (state) => state.domainConfig,
			// 获取所有分类
			categories: (state) => state.categories,
			// 分类是否已加载
			categoriesLoaded: (state) => state.categoriesLoaded,
			// 通过ID或value获取特定分类
			getCategoryByValue: (state) => (value) => {
				return state.categories.find((cat) => cat.value === value || cat.id === value) || null
			},
			// 获取品牌列表
			brandList: (state) => state.brandList,
			// 品牌列表是否已加载
			brandListLoaded: (state) => state.brandListLoaded,
			// 车辆列表状态
			carListState: (state) => state.carListState,
			isFromDetail: (state) => state.carListState.fromDetail,
			currentPage: (state) => state.carListState.currentPage,
			filters: (state) => state.carListState.filters,
			lastVisitedPage: (state) => state.carListState.lastVisitedPage,
			queryParams: (state) => state.carListState.queryParams,
		},
	})
}
